var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGuideDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    id: "download-alt-4",
    "data-name": "Flat Line",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-line",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("line", {
    id: "primary",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 16,
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "primary-2",
    "data-name": "primary",
    points: "8 12 12 16 16 12",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-3",
    "data-name": "primary",
    d: "M20,16v4a1.08,1.08,0,0,1-1.14,1H5.14A1.08,1.08,0,0,1,4,20V16",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGuideDownloadWhite);
export default __webpack_public_path__ + "static/media/user-guide-download-white.9259fcc2b79df91b30f6a9654b15bcaf.svg";
export { ForwardRef as ReactComponent };